<template>
  <AppHeader />
  <main
    class="pt-header86 bg-background min-h-[calc(100dvh-290px)] min-md:maw-w-[95dvw] md:max-w-full md:p-4"
  >
    <YourAccount />
  </main>
</template>

<script>
import AppHeader from "@/components/common/Header.vue";
import YourAccount from "@/components/Account/YourAccount.vue";

export default {
  name: "YourAccountView",
  components: {
    AppHeader,
    YourAccount,
  },
};
</script>

<style scoped></style>
